import React from 'react';
import { Form, Select } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { DefaultOptionType, SelectProps } from 'antd/lib/select';
import { FieldInputProps, FormikTouched, FormikErrors } from 'formik';

type Props = {
  label?: string | React.ReactNode;
  field: FieldInputProps<any>;
  optionsSelect: DefaultOptionType[];
  setFieldValue: (field: any, value: any) => any;
  selectProps?: SelectProps<any>;
  touched?: boolean | FormikTouched<any> | Array<FormikTouched<any>>;
  error?: string | string[] | FormikErrors<any> | Array<FormikErrors<any>>;
  notFoundContent?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (e) => void;
} & Omit<FormItemProps, 'children'>;

const SelectField: React.FC<Props> = ({
  label,
  touched,
  error,
  field,
  selectProps,
  optionsSelect,
  placeholder,
  setFieldValue,
  onChange,
  notFoundContent,
  disabled,
  ...rest
}) => {
  const handleChange = (e: any): void => {
    setFieldValue(field.name, e);

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <Form.Item
      colon={false}
      label={label}
      validateStatus={error && touched ? 'error' : ''}
      help={(touched && error) as string}
      {...rest}
    >
      <Select
        {...field}
        {...selectProps}
        placeholder={placeholder}
        options={optionsSelect}
        onChange={handleChange}
        notFoundContent={
          <div className="no-data">
            <p>なし</p>
          </div>
        }
        disabled={disabled}
        getPopupContainer={(triggerNode: HTMLElement) => triggerNode?.parentNode as HTMLElement}
        virtual={false}
      />
    </Form.Item>
  );
};

export default SelectField;
